import {clearIdToken} from "../services/auth";
import {store} from "../redux/store";
import {userLogout} from "../redux/reducers/authReducer";
import {socket} from "../socket";
import {apiLogout} from "../services/index";

export const logoutHandler = () => {
        // logout from api
        apiLogout().catch((err) => {})


        // 1️⃣ Desconectar socket de forma segura
        if (socket && socket.connected) {
            socket.disconnect();
        }

        // 2️⃣ Limpiar token
        clearIdToken();

        // 3️⃣ Limpiar Redux
        store.dispatch(userLogout());






};
